import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { StartService } from '../../services/start-service.service';
import { ApiDataSectionsResponse } from '../../interfaces';
import {
  getSections,
  getSectionsFailure,
  getSectionsSuccess,
  initializeApiData,
} from './api-data.actions';

@Injectable()
export class ApiDataEffects {
  initialize$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initializeApiData),
      map(({ sessionKey }) => getSections({ sessionKey }))
    )
  );

  getSections$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getSections),
      switchMap(({ sessionKey }) =>
        this.startService.GetSections(sessionKey).pipe(
          map((res: ApiDataSectionsResponse) =>
            getSectionsSuccess({
              sections: res?.refbooks ?? [],
            })
          ),
          catchError(() => of(getSectionsFailure()))
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly startService: StartService
  ) {}
}
